/* eslint-disable import/no-default-export */
import Modals from './components/Modals';

export { Modals };
export default Modals;
